import { render } from "./ModelSearch.vue?vue&type=template&id=1f205372"
import script from "./ModelSearch.vue?vue&type=script&lang=js"
export * from "./ModelSearch.vue?vue&type=script&lang=js"

import exportComponent from "/app/packages/usg_theme/vueproject/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__